<template>
  <ul  v-if="sponsors?.length" :class="$style.root">
    <li v-for="sponsor in sponsors" :key="sponsor.id" :class="$style.item">
      <a :href="sponsor?.attributes?.urlToWebsite" :class="$style.link" target="_blank">
        <CoreImageComponent
          v-if="sponsor?.attributes?.logo?.data?.attributes"
          :image="sponsor?.attributes?.logo?.data?.attributes"
        />
      </a>
    </li>
  </ul>
</template>

<script lang="ts" setup>
const props = defineProps<{
  sponsors: array
}>()
</script>

<style module>
.root {
  composes: reset-list from global;

  display: grid;
  grid-template-columns: repeat(auto-fill, var(--width--sponsor-logo));
  /* gap: var(--stroke--default); */
}

.item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: .25rem;
}

.item * {
  filter: grayscale(1);
}

.item:not(:last-of-type) {
  border-right: var(--stroke--default) solid;
}

[data-page-type="exhibitions"] .item * {
  filter: grayscale(1) invert(1);
}

.link {
  composes: reset-link from global;
}
</style>
